var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_25_2678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 8",
    d: "M3.21552 7.10402C3.58223 6.36041 4.64255 6.36041 5.00926 7.10401L7.92383 13.0141C8.25156 13.6786 7.76794 14.4564 7.02696 14.4564H1.19782C0.456839 14.4564 -0.0267805 13.6786 0.300953 13.0141L3.21552 7.10402Z",
    fill: "#118F79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 9",
    d: "M3.66395 7.32516C3.84731 6.95336 4.37747 6.95336 4.56083 7.32516L7.47539 13.2352C7.63926 13.5675 7.39745 13.9564 7.02696 13.9564H1.19782C0.827331 13.9564 0.585521 13.5675 0.749388 13.2352L3.66395 7.32516Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 7",
    d: "M8.89138 2.45689C9.25809 1.71328 10.3184 1.71328 10.6851 2.45689L15.8915 13.0141C16.2192 13.6787 15.7356 14.4564 14.9946 14.4564H4.5819C3.84092 14.4564 3.3573 13.6787 3.68503 13.0141L8.89138 2.45689Z",
    fill: "#118F79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 584",
    d: "M8.43473 5.56394L9.16569 6.20106C9.54516 6.53182 10.1113 6.52894 10.4874 6.19435L11.1881 5.57098C11.5517 5.24754 11.6296 4.70935 11.3728 4.29604L10.0896 2.23112C10.0465 2.16173 9.9808 2.10929 9.90358 2.08262C9.74513 2.02788 9.56997 2.09117 9.48311 2.23454L8.23654 4.29189C7.98459 4.70771 8.06822 5.24448 8.43473 5.56394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 6",
    d: "M9.33981 2.67804C9.52317 2.30623 10.0533 2.30623 10.2367 2.67803L15.443 13.2353C15.6069 13.5676 15.3651 13.9564 14.9946 13.9564H4.5819C4.21141 13.9564 3.9696 13.5676 4.13347 13.2353L9.33981 2.67804Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 583",
    d: "M7.84167 5.02502L9.14396 6.21879C9.52462 6.56772 10.1084 6.56944 10.4911 6.22276L11.7359 5.09505",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_2678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShan);
export default __webpack_public_path__ + "static/media/shan.792839445050744b3d7802b586b86606.svg";
export { ForwardRef as ReactComponent };